<script setup lang="ts">
import { useSessionStore } from '@/stores/SessionStore.ts';
import Loader from '@/components/loader/Loader.vue';

const sessionStore = useSessionStore();
</script>

<template>
    <div
        v-if="sessionStore.isFullLoading"
        class="absolute z-50 flex h-full w-full select-none items-center justify-center bg-gray-700 opacity-50"
    >
        <Loader :width="62" :height="62" />
    </div>
</template>
